import { useTranslation } from "react-i18next";
import SettingsHeader from './console/SettingsHeader';
import { ReactNode } from "react";

function ConfirmEmail(): ReactNode {
    const { t } = useTranslation(['confirm_email', 'base']);

    return (
        <>
            <SettingsHeader />
            <div className="max-width text-page-padding">
                <h1>{t('string_1')}</h1>
                <p>{t('string_2')}</p>
            </div>
        </>
    )
}

export default ConfirmEmail;